import React from 'react';
import { SegmentsHeader } from '../SegmentsHeader';
import { SegmentsArea } from '../SegmentsArea';
import { ModalCreateEditSegments } from '../ModalCreateEditSegments';
import { useSetupISACustomSegmentsStore } from '../../SetupISACustomSegments.store';
import { ModalRemoveSegment } from '../ModalRemoveSegment';
import { LoadingSpinerArea } from '../../../../../../../components';
import { UploadAlert } from '../UploadAlert';

export const ConfigFormSetupISACustomSegments = () => {
  const { openModalCreateEditSegment, openModalRemoveSegment } = useSetupISACustomSegmentsStore();

  return (
    <div>
      <LoadingSpinerArea size="md" area="custom-segment" />
      <SegmentsHeader />
      <UploadAlert />
      <SegmentsArea />
      <ModalCreateEditSegments show={openModalCreateEditSegment} />
      <ModalRemoveSegment show={openModalRemoveSegment} />
    </div>
  );
};
